<template>
  <a-modal
    title="新建课程专题"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    width=""
    centered
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    okText="保存"
    :getContainer="getContainer"
  >
    <div class="content">
      <div class="content1">
        <FormItem label="课程分类">
          <a-input
            size="large"
            v-model="dataForm.classify"
            placeholder="请输入课程分类"
          />
        </FormItem>
        <br />
        <FormItem label="上传课程">
          <SelectFile
            ref="SelectFile"
            :selectStyle="{ height: '40px' }"
            multiple
            @change="specifiName"
            label="请选择课程"
            accept=".mp4,.mov,.doc,.docx,.pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,.png,.jpg,.jepg"
          />
        </FormItem>
        <div class="downloadFile" v-if="files.length > 0">
          已选择{{ files.length }}个文件
        </div>
        <div class="downloadFile">
          <a-icon type="exclamation-circle" style="color: #b3b9bf" />
          请选择视频(mp4)、word、ppt、pdf格式的文件，可选择多个文件(多选文件时按住"ctrl"键)
        </div>
        <div class="downloadFile" style="color: red">
          <a-icon type="exclamation-circle" />
          保存后请不要随意再修改文件位置
        </div>
      </div>
      <div class="content2" v-if="files.length > 0">
        <div>待保存列表：</div>
        <!-- <div>(已存在待保存列表的文件会帮您自动过滤)</div> -->
        <a-list item-layout="horizontal" :data-source="files">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta>
              <a slot="title" style="color: #000">{{ item.fileName }}</a>
              <div slot="description" class="description">
                <div class="left">
                  <div>{{ "文件大小：" + formatFileSize(item.size) }}</div>
                  <div>{{ "格式：" + getExtension(item.type) }}</div>
                </div>
                <div class="del">
                  <a @click="delFile(index)">
                    <a-icon
                      type="close-circle"
                      style="color: red; font-size: 18px"
                    />
                  </a>
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { companyFileBatch } from "@/utils/exportFile";
import { isDateOrDateTime, excelTimeFormat } from "@/utils/util";
import SelectFile from "@/components/SelectFile/index";
import { addClasses } from "@/request/classes";
import FormItem from "@/components/FormItem/index";
import { getExtension } from "mime";
import { isVideoFileType } from "@/utils/util";
export default {
  components: { SelectFile, FormItem },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      dataForm: {
        classify: "",
      },
      files: [],
    };
  },
  methods: {
    getExtension,
    init() {
      this.visible = true;
    },
    formatFileSize(size) {
      if (size === 0) {
        return "0 B";
      }
      const units = ["B", "KB", "MB", "GB", "TB"];
      const base = 1024;
      const digitGroups = Math.floor(Math.log10(size) / Math.log10(base));
      const formattedSize = (size / Math.pow(base, digitGroups)).toFixed(2);
      return `${formattedSize} ${units[digitGroups]}`;
    },
    //删除上传的文件
    delFile(index) {
      this.files.splice(index, 1);
    },
    //选择的文件地址回调
    async specifiName($event) {
      console.log("选择的文件地址回调");
      let files = [];
      for (let i = 0; i < document.getElementById("open").files.length; i++) {
        // console.log(document.getElementById("open").files[i]);
        const file = document.getElementById("open").files[i];
        if (isVideoFileType(file.name)) {
          file.duration = await this.getDu(file);
        }
        file.fileName = file.name.split(".").slice(0, -1).join("."); //文件名
        file.fileExtension = file.name.split(".").pop(); //拓展名
        if (this.files.findIndex((v) => v.path == file.path) == -1) {
          files.push(file);
          console.log(file);
        } else {
          this.$notification["warning"]({
            message: "提示",
            description: `文件：【${file.name}】已存在待保存列表中`,
          });
        }
      }
      this.files.push(...files);
      $event.srcElement.value = ""; //及时清空
    },
    getDu(file) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.onload = () => {
          var video = document.createElement("video");
          video.src = reader.result;
          const eventFn = () => {
            const duration = Math.floor(video.duration * 100) / 100;
            video.removeEventListener("loadedmetadata", eventFn);
            resolve(duration);
          };
          video.addEventListener("loadedmetadata", eventFn);
        };
        reader.readAsDataURL(file);
      });
    },
    isTableFile(url) {
      // 在正则表达式中使用 $ 表示字符串的结尾
      var regex = /\.xlsx$|\.xls$|\.csv$/i; // 匹配 .xlsx、.xls 或 .csv 结尾的文件
      return regex.test(url);
    },
    handleOk() {
      if (!this.dataForm.classify)
        return this.$message.warning("请输入课程分类");
      if (this.files.length == 0)
        return this.$message.warning("请选择上传文件");
      this.confirmLoading = true;
      const data = this.files.map((v) => {
        return {
          name: v.fileName,
          duration: v.duration ? v.duration : 0,
          url: v.path,
          classify: this.dataForm.classify,
          fileExtension: v.fileExtension,
        };
      });
      addClasses({ arr: data })
        .then(() => {
          this.$message.success("新建课程专题成功");
          this.handleCancel();
        })
        .finally(() => {
          this.confirmLoading = false;
          this.$emit("ok");
        });
    },
    handleCancel() {
      this.files = [];
      this.dataForm.classify = "";
      this.confirmLoading = false;
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.downloadFile {
  font-size: 12px;
  color: #011733;
  margin-top: 15px;
  cursor: pointer;
  display: inline-block;
  padding-left: 94px;
}

.content {
  display: flex;
}
.content1 {
  width: 350px;
}
.content2 {
  width: 300px;
  margin-left: 20px;
  max-height: 80vh;
  overflow-y: auto;
}
.description {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left {
  width: 80%;
}
.del {
}
</style>